// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhyHostForm-space1-sR4LQ {
	margin-bottom: 6px !important;
}

.WhyHostForm-space2-xzAJW {
	margin-bottom: 12px !important;
}

.WhyHostForm-space3-iaMq8 {
	margin-bottom: 18px !important;
}

.WhyHostForm-space4-cO_Cj {
	margin-bottom: 24px !important;
}

.WhyHostForm-space5-DR0nz {
	margin-bottom: 30px !important;
}

.WhyHostForm-space6-OCpKi {
	margin-bottom: 36px !important;
}

.WhyHostForm-space7-h844H {
	margin-bottom: 42px !important;
}

.WhyHostForm-space8-OnL0Y {
	margin-bottom: 48px !important;
}

.WhyHostForm-spaceTop1-wrM4o {
	margin-top: 6px !important;
}

.WhyHostForm-spaceTop2-UnHZ2 {
	margin-top: 12px !important;
}

.WhyHostForm-spaceTop3-IQAPt {
	margin-top: 18px !important;
}

.WhyHostForm-spaceTop4-IbSSw {
	margin-top: 24px !important;
}

.WhyHostForm-spaceTop5-RPUvF {
	margin-top: 30px !important;
}

.WhyHostForm-spaceTop6-SKeYS {
	margin-top: 36px !important;
}

.WhyHostForm-spaceTop7-NoZID {
	margin-top: 42px !important;
}

.WhyHostForm-spaceTop8-exqRy {
	margin-top: 48px !important;
}

.WhyHostForm-noMargin-oQjLM {
	margin: 0px !important;
}

.WhyHostForm-padding1-CZFO8 {
	padding-bottom: 6px !important;
}

.WhyHostForm-padding2-j4xJy {
	padding-bottom: 12px !important;
}

.WhyHostForm-padding3-M6eaT {
	padding-bottom: 18px !important;
}

.WhyHostForm-padding4-zKVMO {
	padding-bottom: 24px !important;
}

.WhyHostForm-padding5-IPf6l {
	padding-bottom: 30px !important;
}

.WhyHostForm-padding6-tl3xh {
	padding-bottom: 36px !important;
}

.WhyHostForm-padding7-OyCdl {
	padding-bottom: 42px !important;
}

.WhyHostForm-paddingTop1-hfftI {
	padding-top: 6px !important;
}

.WhyHostForm-paddingTop2-jy50P {
	padding-top: 12px !important;
}

.WhyHostForm-paddingTop3-acB1e {
	padding-top: 18px !important;
}

.WhyHostForm-paddingTop4-gHQiW {
	padding-top: 24px !important;
}

.WhyHostForm-paddingTop5-UWp8A {
	padding-top: 30px !important;
}

.WhyHostForm-paddingTop6-ancA_ {
	padding-top: 36px !important;
}

.WhyHostForm-paddingTop7-Rl2ZF {
	padding-top: 42px !important;
}

.WhyHostForm-noPadding-dVw_l {
	padding: 0px !important;
}

.WhyHostForm-spaceMarginBottom0-qgGrP {
	margin-bottom: 0;
}

.WhyHostForm-textBold-zQ3aE {
	font-weight: 500 !important;
}

.WhyHostForm-textBolder-XpWvP {
	font-weight: 700 !important;
}

.WhyHostForm-textNormal-htzyD {
	font-weight: normal !important;
}

/*New Design Text Colors */

.WhyHostForm-textDarkBlue-sr85l {
	color: rgb(20, 39, 94) !important;
}

.WhyHostForm-textLightBlue-MK289 {
	color: rgb(57, 87, 106) !important;
}

.WhyHostForm-textLightSandleGreen-KaP9B {
	color: rgb(76, 86, 41) !important;
}

.WhyHostForm-textLightBrown-B3ypj {
	color: rgb(115, 79, 33) !important;
}

.WhyHostForm-textMediumMaroon-lcmOs {
	color: rgb(87, 37, 51) !important;
}

.WhyHostForm-textBrown-KDmjw {
	color: rgb(160, 47, 24) !important;
}

.WhyHostForm-textMaroon-wP_25 {
	color: rgb(155, 49, 67) !important;
}

.WhyHostForm-textDarkBrown-aJqYA {
	color: rgb(83, 18, 16) !important;
}

.WhyHostForm-textMediumBrown-ZnHIC {
	color: rgb(142, 28, 10) !important;
}

.WhyHostForm-textSkyBlue-_KE_d {
	color: rgb(37, 117, 141) !important;
}

.WhyHostForm-textGray-q96fV {
	color: rgb(77, 65, 51) !important;
}

.WhyHostForm-errorMessage-Y6b3I {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.WhyHostForm-userText-EqIjy {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.WhyHostForm-panelHeader-dpvV6 {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.WhyHostForm-exportSection-hZ6Y7 {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.WhyHostForm-exportSectionGridSub-FS70i {
	grid-template-columns: 50% 49% !important;
}

.WhyHostForm-exportText-PohoY {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.WhyHostForm-exportLinkImg-g1BJ9 {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.WhyHostForm-exportImg-ZxT4S {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.WhyHostForm-linkBtn-ZShsp {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.WhyHostForm-table-YoHvS {
	display: table;
}

.WhyHostForm-tableRow-hOJQh {
	display: table-row;
}

.WhyHostForm-tableCell-CovJO {
	display: table-cell;
	float: none;
}

.WhyHostForm-formGroup-Rn3GH {
	margin-bottom: 6px;
}

.WhyHostForm-marginTop0-QPOXC {
	margin-top: 0;
}

.WhyHostForm-marginBottom20-tn6UP {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.WhyHostForm-bannerImageBg-J2CTm {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.WhyHostForm-bannerDelete-jqACp {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.WhyHostForm-exportLink-mEl4q {
	padding-top: 10px;
	padding-right: 10px;
}

.WhyHostForm-seachContent-ViO91 {
	padding-left: 0px;
	margin-bottom: 5px;
}

.WhyHostForm-marginBottom9-A96Gr {
	margin-bottom: 9px;
}

.WhyHostForm-spaceTop52-jSpFy {
	margin-top: 52px;
}

.WhyHostForm-profileViewInner-NnSTa {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.WhyHostForm-profileViewMain-JGccD {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.WhyHostForm-profileViewlabel-YH36v {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.WhyHostForm-profileViewMainContent-Z2s1F {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.WhyHostForm-reviewsFormStar-vHjGk {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.WhyHostForm-reviewsFormStar-vHjGk svg {
	cursor: pointer;
}

.WhyHostForm-addLanguageText-zyNfz {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.WhyHostForm-exportSection-hZ6Y7 {
		grid-template-columns: 100%;
	}

	.WhyHostForm-spaceTop52-jSpFy {
		margin-top: 18px;
	}

	.WhyHostForm-exportText-PohoY {
		float: none;
		margin-top: 12px;
	}

	.WhyHostForm-exportSectionGridSub-FS70i {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.WhyHostForm-profileViewlabel-YH36v {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.WhyHostForm-profileViewMainContent-Z2s1F {
		width: 100%;
		text-align: center;
	}

	.WhyHostForm-panelHeader-dpvV6 {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.WhyHostForm-sectionBorder-SdVGP {
    border: 1px solid var(--border-secondary-color);
    border-radius: 6px;
    margin-bottom: 25px;
    padding: 15px;

}

.WhyHostForm-removeIcon-wXEFX:hover {
    cursor: pointer;
}

.WhyHostForm-removeIcon-wXEFX {
    width: 26px;
}

.WhyHostForm-whyFromGrid-G8Bgg {
    display: grid;
    grid-template-columns: 49% 49%;
    grid-column-gap: 22px;
}

.WhyHostForm-specialPriceIcon-yaA0f {
    position: relative;
    display: inline-block;
    width: 14px;
    margin-left: 4px;
    cursor: pointer;
}

.WhyHostForm-toolTip-GDvTL {
    position: absolute;
    top: 30px;
    right: 0;
    left: -11px;
    display: none;
    background: var(--primary-white-bg);
    min-width: 280px;
    text-align: center;
    padding: 8px;
    border-radius: 4px;
    color: var(--common-text-color);
    border: 1px solid var(--primary-border);
    font-size: 14px;
    z-index: 2;
}

.WhyHostForm-specialPriceIcon-yaA0f:hover .WhyHostForm-toolTip-GDvTL {
    display: block;
}

.WhyHostForm-toolTipRelativeSection-kjRWa::after {
    content: '';
    height: 100%;
    width: 100%;
    position: absolute;
    left: 12px;
    right: 0;
    top: -6px;
    text-align: center;
    background-color: var(--primary-white-bg);
    z-index: 0;
    max-width: 10px;
    max-height: 10px;
    -webkit-transform: rotate(136deg);
    -ms-transform: rotate(136deg);
    transform: rotate(136deg);
    border: 1px solid var(--primary-border);
    border-top-width: 0;
    border-right-width: 0;
}

.WhyHostForm-dFlex-o9R5G {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: baseline;
        -ms-flex-align: baseline;
            align-items: baseline;
}

@media screen and (max-width: 1199px) {
    .WhyHostForm-whyFromGrid-G8Bgg {
        grid-template-columns: 100%;
    }
}

@media screen and (max-width: 767px) {
    .WhyHostForm-toolTip-GDvTL {
        min-width: 165px;
    }

    .WhyHostForm-toolTipRelativeSection-kjRWa::after {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/WhyHostForm/WhyHostForm.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACrN3E;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;;AAEjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,aAAa;IACb,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;IAC/B,uCAAuC;IACvC,eAAe;IACf,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,yCAAyC;IACzC,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,uCAAuC;IACvC,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,2BAAqB;QAArB,wBAAqB;YAArB,qBAAqB;AACzB;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n@import '../../helpers.css';\n\n.sectionBorder {\n    border: 1px solid var(--border-secondary-color);\n    border-radius: 6px;\n    margin-bottom: 25px;\n    padding: 15px;\n\n}\n\n.removeIcon:hover {\n    cursor: pointer;\n}\n\n.removeIcon {\n    width: 26px;\n}\n\n.whyFromGrid {\n    display: grid;\n    grid-template-columns: 49% 49%;\n    grid-column-gap: 22px;\n}\n\n.specialPriceIcon {\n    position: relative;\n    display: inline-block;\n    width: 14px;\n    margin-left: 4px;\n    cursor: pointer;\n}\n\n.toolTip {\n    position: absolute;\n    top: 30px;\n    right: 0;\n    left: -11px;\n    display: none;\n    background: var(--primary-white-bg);\n    min-width: 280px;\n    text-align: center;\n    padding: 8px;\n    border-radius: 4px;\n    color: var(--common-text-color);\n    border: 1px solid var(--primary-border);\n    font-size: 14px;\n    z-index: 2;\n}\n\n.specialPriceIcon:hover .toolTip {\n    display: block;\n}\n\n.toolTipRelativeSection::after {\n    content: '';\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    left: 12px;\n    right: 0;\n    top: -6px;\n    text-align: center;\n    background-color: var(--primary-white-bg);\n    z-index: 0;\n    max-width: 10px;\n    max-height: 10px;\n    -webkit-transform: rotate(136deg);\n    -ms-transform: rotate(136deg);\n    transform: rotate(136deg);\n    border: 1px solid var(--primary-border);\n    border-top-width: 0;\n    border-right-width: 0;\n}\n\n.dFlex {\n    display: flex;\n    align-items: baseline;\n}\n\n@media screen and (max-width: 1199px) {\n    .whyFromGrid {\n        grid-template-columns: 100%;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .toolTip {\n        min-width: 165px;\n    }\n\n    .toolTipRelativeSection::after {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `WhyHostForm-space1-sR4LQ`,
	"space2": `WhyHostForm-space2-xzAJW`,
	"space3": `WhyHostForm-space3-iaMq8`,
	"space4": `WhyHostForm-space4-cO_Cj`,
	"space5": `WhyHostForm-space5-DR0nz`,
	"space6": `WhyHostForm-space6-OCpKi`,
	"space7": `WhyHostForm-space7-h844H`,
	"space8": `WhyHostForm-space8-OnL0Y`,
	"spaceTop1": `WhyHostForm-spaceTop1-wrM4o`,
	"spaceTop2": `WhyHostForm-spaceTop2-UnHZ2`,
	"spaceTop3": `WhyHostForm-spaceTop3-IQAPt`,
	"spaceTop4": `WhyHostForm-spaceTop4-IbSSw`,
	"spaceTop5": `WhyHostForm-spaceTop5-RPUvF`,
	"spaceTop6": `WhyHostForm-spaceTop6-SKeYS`,
	"spaceTop7": `WhyHostForm-spaceTop7-NoZID`,
	"spaceTop8": `WhyHostForm-spaceTop8-exqRy`,
	"noMargin": `WhyHostForm-noMargin-oQjLM`,
	"padding1": `WhyHostForm-padding1-CZFO8`,
	"padding2": `WhyHostForm-padding2-j4xJy`,
	"padding3": `WhyHostForm-padding3-M6eaT`,
	"padding4": `WhyHostForm-padding4-zKVMO`,
	"padding5": `WhyHostForm-padding5-IPf6l`,
	"padding6": `WhyHostForm-padding6-tl3xh`,
	"padding7": `WhyHostForm-padding7-OyCdl`,
	"paddingTop1": `WhyHostForm-paddingTop1-hfftI`,
	"paddingTop2": `WhyHostForm-paddingTop2-jy50P`,
	"paddingTop3": `WhyHostForm-paddingTop3-acB1e`,
	"paddingTop4": `WhyHostForm-paddingTop4-gHQiW`,
	"paddingTop5": `WhyHostForm-paddingTop5-UWp8A`,
	"paddingTop6": `WhyHostForm-paddingTop6-ancA_`,
	"paddingTop7": `WhyHostForm-paddingTop7-Rl2ZF`,
	"noPadding": `WhyHostForm-noPadding-dVw_l`,
	"spaceMarginBottom0": `WhyHostForm-spaceMarginBottom0-qgGrP`,
	"textBold": `WhyHostForm-textBold-zQ3aE`,
	"textBolder": `WhyHostForm-textBolder-XpWvP`,
	"textNormal": `WhyHostForm-textNormal-htzyD`,
	"textDarkBlue": `WhyHostForm-textDarkBlue-sr85l`,
	"textLightBlue": `WhyHostForm-textLightBlue-MK289`,
	"textLightSandleGreen": `WhyHostForm-textLightSandleGreen-KaP9B`,
	"textLightBrown": `WhyHostForm-textLightBrown-B3ypj`,
	"textMediumMaroon": `WhyHostForm-textMediumMaroon-lcmOs`,
	"textBrown": `WhyHostForm-textBrown-KDmjw`,
	"textMaroon": `WhyHostForm-textMaroon-wP_25`,
	"textDarkBrown": `WhyHostForm-textDarkBrown-aJqYA`,
	"textMediumBrown": `WhyHostForm-textMediumBrown-ZnHIC`,
	"textSkyBlue": `WhyHostForm-textSkyBlue-_KE_d`,
	"textGray": `WhyHostForm-textGray-q96fV`,
	"errorMessage": `WhyHostForm-errorMessage-Y6b3I`,
	"userText": `WhyHostForm-userText-EqIjy`,
	"panelHeader": `WhyHostForm-panelHeader-dpvV6`,
	"exportSection": `WhyHostForm-exportSection-hZ6Y7`,
	"exportSectionGridSub": `WhyHostForm-exportSectionGridSub-FS70i`,
	"exportText": `WhyHostForm-exportText-PohoY`,
	"exportLinkImg": `WhyHostForm-exportLinkImg-g1BJ9`,
	"exportImg": `WhyHostForm-exportImg-ZxT4S`,
	"linkBtn": `WhyHostForm-linkBtn-ZShsp`,
	"table": `WhyHostForm-table-YoHvS`,
	"tableRow": `WhyHostForm-tableRow-hOJQh`,
	"tableCell": `WhyHostForm-tableCell-CovJO`,
	"formGroup": `WhyHostForm-formGroup-Rn3GH`,
	"marginTop0": `WhyHostForm-marginTop0-QPOXC`,
	"marginBottom20": `WhyHostForm-marginBottom20-tn6UP`,
	"bannerImageBg": `WhyHostForm-bannerImageBg-J2CTm`,
	"bannerDelete": `WhyHostForm-bannerDelete-jqACp`,
	"exportLink": `WhyHostForm-exportLink-mEl4q`,
	"seachContent": `WhyHostForm-seachContent-ViO91`,
	"marginBottom9": `WhyHostForm-marginBottom9-A96Gr`,
	"spaceTop52": `WhyHostForm-spaceTop52-jSpFy`,
	"profileViewInner": `WhyHostForm-profileViewInner-NnSTa`,
	"profileViewMain": `WhyHostForm-profileViewMain-JGccD`,
	"profileViewlabel": `WhyHostForm-profileViewlabel-YH36v`,
	"profileViewMainContent": `WhyHostForm-profileViewMainContent-Z2s1F`,
	"reviewsFormStar": `WhyHostForm-reviewsFormStar-vHjGk`,
	"addLanguageText": `WhyHostForm-addLanguageText-zyNfz`,
	"sectionBorder": `WhyHostForm-sectionBorder-SdVGP`,
	"removeIcon": `WhyHostForm-removeIcon-wXEFX`,
	"whyFromGrid": `WhyHostForm-whyFromGrid-G8Bgg`,
	"specialPriceIcon": `WhyHostForm-specialPriceIcon-yaA0f`,
	"toolTip": `WhyHostForm-toolTip-GDvTL`,
	"toolTipRelativeSection": `WhyHostForm-toolTipRelativeSection-kjRWa`,
	"dFlex": `WhyHostForm-dFlex-o9R5G`
};
module.exports = ___CSS_LOADER_EXPORT___;
